export enum LoadingBarIntent {
  Info = "info",
  Success = "success",
  Warning = "warning",
  Error = "error",
}
